import { render, staticRenderFns } from "./recebimento-monitor-right-nav-bar.vue?vue&type=template&id=e2491b66&scoped=true"
import script from "./recebimento-monitor-right-nav-bar.vue?vue&type=script&lang=ts"
export * from "./recebimento-monitor-right-nav-bar.vue?vue&type=script&lang=ts"
import style0 from "./recebimento-monitor-right-nav-bar.vue?vue&type=style&index=0&id=e2491b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2491b66",
  null
  
)

export default component.exports